<template>
    <div>
        <main style='background: #EEEEEE;height: 900px;'>
            <img src="../../assets/images/banner_bg.jpg" alt="" class="topImg">
            <div class="centerBox">
                <div class="liucheng">
                    <div>
                        <p class="title">司法鉴定机构查询</p>
                        <div class="boxItems">
                            <div class="left">
                                <input id="tipinput" placeholder="请输入关键词进行地址查询" :value="address"  />
                                <v-distpicker @selected='onSelected' @province="getProvince" @city="getCity" @area="getArea"></v-distpicker>
                                <div class="address" >
                                    <div class="addItem" v-for="(item,index) in organList" :key="index" @click="goDetails(item.id)">
                                        <p>{{item.name}}</p>
                                        <p>{{item.address}}</p>
                                    </div>

                                </div>
                                <!-- <input type="" name="" id="tipinput" value="" style="width: 100%;height: 30px;border: 1px solid red;" /> -->
                                <!-- <el-input v-model="input" id="tipinput" placeholder="请输入关键词进行查询"></el-input> -->
                            </div>
                            <div id="container" style="width: calc(70% - 30px); height:560px;float:left;margin-left: 30px;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import navheader from '../../components/navheader.vue'
    import footeritem from '../../components/footeritem.vue'
    import VDistpicker from 'v-distpicker'
    import axios from 'axios'
    import '../../assets/css/index.less'
    import '../../assets/css/fuWu.less';
    export default {
        name: 'Pdf',
        components: {
            navheader,
            footeritem,
            VDistpicker
        },
        data() {
            return {
                value: '',
                address:'',
                activeNum: 0,
                organList:[],
                province:'',
                city:'',
                area:'',
            };
        },
        methods: {
			//跳转详情
			goDetails(xxbh){
				this.$router.push({name:'jgDetails',query:{xxbh:xxbh}})
			},
            onSelected(data){
            },

            getProvince(data){
                this.province = data.value
                this. getOrganList();
            },
            getCity(data){
                this.city = data.value
                this. getOrganList();
            },

            getArea(data){

                this.area = data.value
                this. getOrganList();
            },


            changeAddress(value){

            },

            getOrganList() {
                axios.post('/system/JG/organList',{'sfjdjgmc':'','province':this.province,'city':this.city,'area':this.area}).then(res => {
                    if (res.data.code == 200) {
                        this.organList=res.data.data
                    }
                }, err => {})
            },
            select() {
                //地图加载
                var map = new AMap.Map("container", {
                    resizeEnable: true
                });
                //输入提示
                var autoOptions = {
                    input: "tipinput"
                };
                var auto = new AMap.Autocomplete(autoOptions);
                var placeSearch = new AMap.PlaceSearch({
                    map: map
                }); //构造地点查询类
                AMap.event.addListener(auto, "select", select); //注册监听，当选中某条记录时会触发
                function select(e) {
                    placeSearch.setCity(e.poi.adcode);
                    placeSearch.search(e.poi.name); //关键字查询查询
                }

            }
        },
        created() {

        },
        mounted() {
            let that = this;
            this.select()
            this.getOrganList();
        },
    };
</script>

<style lang="less" scoped="scoped">
    /deep/ .distpicker-address-wrapper select{
        margin-top: 10px;
    }
    .address{
        width: 100%;
        height: 400px;
        overflow-y: auto;
        margin-top: 20px;
        .addItem{
            width: 100%;
            border-bottom: 1px dashed #BEBEBE;
            margin-bottom: 10px;
            p{
                width: 100%;
                margin-bottom: 10px;
                &:first-of-type{
                    font-size: 16px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Semibold;
                    font-weight: 600;
                    text-align: left;
                    color: #000000;
                }
                &:last-of-type{
                    font-size: 14px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                    font-weight: 400;
                    text-align: left;
                    color: #999999;
                }
            }
        }
    }
    .topImg {
        width: 100%;
        display: block;
    }

    .centerBox {
        width: 1134px;
        margin: 0 auto;
        overflow: hidden;
        box-sizing: border-box;
    }

    .titleTip {
        width: 100%;
        border-left: 4px solid #01458E;
        padding-left: 10px;
    }

    .liucheng {
        position: absolute;
        top: 300px;
        left: 50%;
        margin-left: -500px;

        // background: #F8F8F8;
        // padding: 30px 0;
        &>div {
            width: 1000px;
            height: 700px;
            margin: 0 auto;
            box-shadow: 0px 0px 0px NaNpx rgba(4, 32, 89, 0.15);
            box-sizing: border-box;
            border-radius: 10px;
            background: #fff;
            overflow: hidden;

            .title {
                width: 100%;
                height: 67px;
                line-height: 67px;
                background: #0068d8;
                padding: 0 30px;
                box-sizing: border-box;
                font-size: 22px;
                font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                font-weight: 700;
                text-align: left;
                color: #ffffff;
                letter-spacing: 1px;
            }

            .boxItems {
                width: 100%;
                padding: 30px;
                box-sizing: border-box;
                overflow: hidden;

                .left {
                    width: 30%;
                    float: left;
                    input{
                        width: 100%;
                        height: 40px;
                        line-height: 38px;
                        background: #ffffff;
                        border: 1px solid #cacaca;
                        border-radius: 5px;
                        box-shadow: 0px 0px 0px NaNpx rgba(4,32,89,0.15);
                        font-size: 14px;
                        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                        color: #999999;
                        padding: 0 15px;
                        box-sizing: border-box;
                    }
                }
            }

        }

        @media screen and (max-width: 1024px) {
            &>div {
                width: 90%;
            }
        }
    }
</style>
